import { useAppSelector } from '../../store';

import {
  Container,
  ProgressBlock,
  ProgressItem,
  ProgressBar,
} from './progress.styles';

const Progress = () => {
  const { index } = useAppSelector((state) => state.pagination);
  const qs = Array.from(Array(10));

  if (index < 1) {
    return null;
  }

  return (
    <Container>
      {qs.map((_q, i) => {
        return (
          <ProgressBlock key={i}>
            <ProgressItem isActive={i + 1 === index} isComplete={i + 1 < index}>
              {i + 1}
            </ProgressItem>
            <ProgressBar isComplete={i + 1 < index} step={i} />
          </ProgressBlock>
        );
      })}
    </Container>
  );
};

export default Progress;
